var _path, _rect, _path2, _circle, _rect2, _path3, _circle2, _path4, _path5, _circle3, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVisuelSettings(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 171,
    height: 266,
    viewBox: "0 0 171 266",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3C0 1.34315 1.34315 0 3 0H171V266H3C1.34314 266 0 264.657 0 263V3Z",
    fill: "#8B57DF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 171,
    height: 120,
    transform: "translate(0 146)",
    fill: "url(#paint0_linear_4671_206616)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M171 146H74H0L0 45.3385C19.249 36.7652 40.568 32 63 32C104.993 32 143.086 48.6995 171 75.8198V146Z",
    fill: "#BA8BEA"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 85.5,
    cy: 125.5,
    r: 52.5,
    stroke: "#F3EAFF",
    strokeWidth: 12
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 70.5605,
    y: 42,
    width: 89.1543,
    height: 66.178,
    rx: 5.74406,
    fill: "url(#paint1_linear_4671_206616)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85 75C85 65.0589 93.0589 57 103 57H127C136.941 57 145 65.0589 145 75C145 84.9411 136.941 93 127 93H103C93.0589 93 85 84.9411 85 75Z",
    fill: "#F3EAFF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 104,
    cy: 75,
    r: 15,
    fill: "#6725D2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M104 65C98.48 65 94 69.48 94 75C94 80.52 98.48 85 104 85C109.52 85 114 80.52 114 75C114 69.48 109.52 65 104 65ZM104 83C99.58 83 96 79.42 96 75C96 73.15 96.63 71.45 97.69 70.1L108.9 81.31C107.55 82.37 105.85 83 104 83ZM110.31 79.9L99.1 68.69C100.45 67.63 102.15 67 104 67C108.42 67 112 70.58 112 75C112 76.85 111.37 78.55 110.31 79.9Z",
    fill: "#F3EAFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M114.178 117.457L106.403 109.682C105.326 108.605 103.865 108 102.341 108H130.076C128.553 108 127.092 108.605 126.014 109.682L118.24 117.457C117.118 118.579 115.3 118.579 114.178 117.457Z",
    fill: "#531BAE"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 67.5,
    cy: 177.5,
    r: 14.5,
    fill: "#BA8BEA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M93.9973 145.776L71.3009 111.213C70.3164 109.738 68.6582 109 67 109C65.3418 109 63.6836 109.738 62.6991 111.266L40.0027 145.776H15.1818C12.3318 145.776 10 148.146 10 151.044C10 151.518 10.0518 151.993 10.2073 152.467L23.3691 201.308C24.5609 205.733 28.5509 209 33.3182 209H100.682C105.449 209 109.439 205.733 110.683 201.308L123.845 152.467L124 151.044C124 148.146 121.668 145.776 118.818 145.776H93.9973ZM51.4545 145.776L67 122.593L82.5455 145.776H51.4545ZM67 187.925C61.3 187.925 56.6364 183.183 56.6364 177.388C56.6364 171.592 61.3 166.85 67 166.85C72.7 166.85 77.3636 171.592 77.3636 177.388C77.3636 183.183 72.7 187.925 67 187.925Z",
    fill: "url(#paint2_linear_4671_206616)",
    stroke: "#8B57DF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4671_206616",
    x1: 85.5,
    y1: 0,
    x2: 85.5,
    y2: 120,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA8BEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390044,
    stopColor: "#BA8BEA",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.791093,
    stopColor: "#BA8BEA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4671_206616",
    x1: 115.138,
    y1: 42,
    x2: 115.138,
    y2: 108.178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.400461,
    stopColor: "#6725D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#531BAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4671_206616",
    x1: 67,
    y1: 109,
    x2: 67,
    y2: 209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.551505,
    stopColor: "#F3EAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFD2ED"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisuelSettings);
export default __webpack_public_path__ + "static/media/visuel_settings.e1a22ca8854fd4e919a67907bef5a96c.svg";
export { ForwardRef as ReactComponent };